const { jQuery: $ } = window;

export default class MarketoPlugin {
    constructor() {
        $(window).one("kmdg_marketo_ready", () => this.marketoIntegration);
    }

    marketoIntegration() {
        throw new Error("Please override this method");
    }
}